import React from 'react'
import Newhome from './Newhome'
import PrivacyPolicy from './PrivacyPolicy'
import Newhomefooter from './Newhomefooter'

const PrivacyPolicypage = () => {
  return (
    <div className="home-page-new">
       <Newhome />
       <PrivacyPolicy />
       <Newhomefooter />
    </div>
  )
}

export default PrivacyPolicypage
